export const readAsText = file => new Promise(res=>{
    const reader = new FileReader()
    reader.onload = event=>res({name:file.name,content:event.target.result, path:file.webkitRelativePath})
    reader.readAsText(file)
  })
